var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as Long from "long";
import { TypeActionReconnectAfterLogin, } from "../../reconnect-after-login/actionReconnectAfterLogin";
import { TypeActionInventoryInfo } from "./actionInventoryInfo";
var initial = {
    building: [],
    package: [],
    profilePicture: [],
    resource: [],
};
export var reducerInventoryInfoReceived = function (state, action) {
    if (state === void 0) { state = initial; }
    switch (action.type) {
        case TypeActionInventoryInfo.Received:
            return __assign({}, state, action.inventoryInfo);
        case TypeActionInventoryInfo.AddBuilding:
            return reducerAddItems(state, action.items, "building");
        case TypeActionInventoryInfo.AddResource:
            return reducerAddItems(state, action.items, "resource");
        case TypeActionInventoryInfo.AddPackage:
            return reducerAddItems(state, action.items, "package");
        case TypeActionInventoryInfo.RemoveBuilding:
            return reducerRemoveItems(state, action.items, "building");
        case TypeActionInventoryInfo.RemoveResource:
            return reducerRemoveItems(state, action.items, "resource");
        case TypeActionInventoryInfo.RemovePackage:
            return reducerRemoveItems(state, action.items, "package");
        case TypeActionInventoryInfo.UpdateResource:
            return reducerUpdateItems(state, action.items, "resource");
        case TypeActionInventoryInfo.UpdateBuilding:
            return reducerUpdateItems(state, action.items, "building");
        case TypeActionInventoryInfo.UpdatePackage:
            return reducerUpdateItems(state, action.items, "package");
        case TypeActionInventoryInfo.UpdateProfilePicture:
            return reducerUpdateItems(state, action.items, "profilePicture");
        case TypeActionInventoryInfo.AddProfilePicture:
            return reducerAddItems(state, action.items, "profilePicture");
        case TypeActionInventoryInfo.RemoveProfilePicture:
            return reducerRemoveItems(state, action.items, "profilePicture");
        case TypeActionReconnectAfterLogin.DisconnectedByLogin:
            return initial;
        default:
            return state;
    }
};
var reducerAddItems = function (state, items, inventoryKey) {
    var _a;
    var summedItems = [];
    items.forEach(function (item) {
        var foundIndex = summedItems.findIndex(function (sumItem) { return sumItem.typeId === item.typeId; });
        if (foundIndex !== undefined && foundIndex !== -1) {
            summedItems[foundIndex].amount = summedItems[foundIndex].amount.add(item.amount);
        }
        else {
            summedItems.push(item);
        }
    });
    return __assign({}, state, (_a = {}, _a[inventoryKey] = (state[inventoryKey] || []).map(function (oldItem) {
        var newItem = findSameItem(summedItems, oldItem);
        return {
            amount: oldItem.amount.add(newItem ? newItem.amount : Long.ZERO),
            stageId: oldItem.stageId,
            typeId: oldItem.typeId,
        };
    }).concat(summedItems.filter(function (item) { return !findSameItem(state[inventoryKey], item); })), _a));
};
var reducerRemoveItems = function (state, items, inventoryKey) {
    var _a;
    return __assign({}, state, (_a = {}, _a[inventoryKey] = (state[inventoryKey] || [])
        .map(function (oldItem) {
        var newItem = findSameItem(items, oldItem);
        return {
            amount: oldItem.amount.subtract(newItem ? newItem.amount : Long.ZERO),
            stageId: oldItem.stageId,
            typeId: oldItem.typeId,
        };
    })
        .filter(function (item) { return item.amount.greaterThan(0); }), _a));
};
var reducerUpdateItems = function (state, items, inventoryKey) {
    var _a;
    return __assign({}, state, (_a = {}, _a[inventoryKey] = (state[inventoryKey] || []).map(function (oldItem) {
        var newItem = findSameItem(items, oldItem);
        return newItem || oldItem;
    }).concat(items.filter(function (item) { return !findSameItem(state[inventoryKey], item); })), _a));
};
var findSameItem = function (list, item) {
    if (list == undefined) {
        return undefined;
    }
    return list.find(function (val) { return (val.stageId || 0) === (item.stageId || 0) && val.typeId === item.typeId; });
};



//////////////////
// WEBPACK FOOTER
// ./src/features/info/inventory/reducerInventoryInfo.ts
// module id = 2534
// module chunks = 3